import a from "react";
import { getIconColor as h } from "./iconfont.es5470.js";
import g from "./iconfont.es5471.js";
const r = {
  display: "block"
}, v = ({ size: t = 16, useVw: n, useRem: o, color: c, withColor: l, removeClassName: e, disableSSR: m, style: i, ...d }) => {
  const p = i ? { ...r, ...i } : r;
  return /* @__PURE__ */ a.createElement(g, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-chongzhimachongzhi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (o ? "rem" : "px"), height: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (o ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: p, fill: "none", ...d }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "24px-åå¼ç åå¼"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: l ? h(c, 0, "#262933") : "#262933",
        datafollowfill: l ? h(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M1.692 6.807a3.691 3.691 0 0 1 3.691-3.691h13.18a3.691 3.691 0 0 1 3.692 3.69V9.12a.8.8 0 0 1-1.6 0V6.807a2.091 2.091 0 0 0-2.091-2.091H5.384a2.091 2.091 0 0 0-2.092 2.09v10.215c0 1.155.937 2.091 2.091 2.091h3.43a.8.8 0 0 1 0 1.6h-3.43a3.691 3.691 0 0 1-3.69-3.69V6.806Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M17.671 14.311a.8.8 0 0 0-1.131-1.131l-3.47 3.47a.8.8 0 0 0 0 1.13l3.47 3.47a.8.8 0 0 0 1.131-1.131l-2.102-2.103h6.923a.8.8 0 1 0 0-1.6h-6.925l2.104-2.105ZM7.035 7.963a.8.8 0 1 0-1.6 0v3.47a.8.8 0 0 0 1.6 0v-3.47Zm2.669-.8a.8.8 0 0 1 .8.8v3.47a.8.8 0 0 1-1.6 0v-3.47a.8.8 0 0 1 .8-.8Zm4.269.8a.8.8 0 0 0-1.6 0v3.47a.8.8 0 0 0 1.6 0v-3.47Z"
        }
      )
    )
  )));
}, s = v;
export {
  s as default
};
